import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  bold: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
  }
}));
